import useSystemStore from '~~/store/system'
import { appIsAndroidOrIOS } from '~~/utils/index'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('safeBottom', {
    mounted(el, { arg }) {
      const systemStore = useSystemStore()
      const safeHeight = systemStore.info.bottomSafeH
      if (safeHeight <= 0) {
        return
      }
      if (arg === 'margin') {
        el.style.marginBottom = `${safeHeight || 40}px`
      } else {
        el.style.paddingBottom = `${safeHeight || 40}px`
      }
    },
  })
  nuxtApp.vueApp.directive('safeTop', {
    mounted(el) {
      const systemStore = useSystemStore()
      const safeHeight = systemStore.info.safeTop
      if (safeHeight <= 0) {
        return
      }
      el.style.paddingTop = `${safeHeight}px`
    },
  })
  // 3D看车横屏用
  nuxtApp.vueApp.directive('safeTopHalf', {
    mounted(el: HTMLElement) {
      const systemStore = useSystemStore()
      const safeHeight = systemStore.info.safeTop
      if (safeHeight <= 0 || appIsAndroidOrIOS() === 'ios') {
        return
      }
      el.style.paddingTop = `${safeHeight / 2}px`
    },
  })
  nuxtApp.vueApp.directive('imgLazy', {
    mounted(el, binding) {
      // 监听元素是否到达可视区域
      const observe = new IntersectionObserver(
        ([{ isIntersecting }]) => {
          if (isIntersecting) {
            // 到达可视区域后停止监听
            observe.unobserve(el)
          }
          el.src = binding.value
        },
        {
          threshold: 0, // 进入可视区域交界开始观察
        },
      )
      observe.observe(el) // 观察当前元素
    },
    // 数据更新时重新设置值
    updated(el, binding) {
      el.src = binding.value
    },
  })
})
